import { Button, Space } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const PeriodNavigator = ({ view, selectedDay, onChange }) => {
  const unit = view === 'week' ? 'week' : 'month';
  const onPrev = () => onChange(selectedDay.subtract(1, unit));
  const onNext = () => onChange(selectedDay.add(1, unit));

  const label =
    view === 'week'
      ? `${selectedDay.startOf('isoWeek').format('D MMM')} – ${selectedDay
          .endOf('isoWeek')
          .format('D MMM YYYY')}`
      : selectedDay.format('MMMM YYYY');

  return (
    <Space size={4}>
      <Button icon={<LeftOutlined />} size="small" onClick={onPrev} />
      <span
        className="text-sm font-medium text-gray-700 text-center"
        style={{ minWidth: 160, display: 'inline-block' }}
      >
        {label}
      </span>
      <Button icon={<RightOutlined />} size="small" onClick={onNext} />
    </Space>
  );
};

export default PeriodNavigator;
